import React from 'react';
import IntroBlock from '../AboutPage/IntroBlock';
import ToolsBlock from '../AboutPage/ToolsBlock';
import Particles from 'react-tsparticles';
import { InView } from 'react-intersection-observer';
import '../../CSS/AboutPage.css';

function AboutPage({showModal, modalTrigger} : {showModal:boolean, modalTrigger:Function}) {

    return (
        <div className="About-frame">
            <Particles
                params={{
                    "particles": {
                        "number": {
                            "value": 60,
                            "density": {
                                "enable": true,
                                "value_area": 1500
                            }
                        },
                        "line_linked": {
                            "enable": true,
                            "opacity": 0.02
                        },
                        "move": {
                            "direction": "right",
                            "speed": 0.05
                        },
                        "size": {
                            "value": 1
                        },
                        "opacity": {
                            "anim": {
                                "enable": true,
                                "speed": 1,
                                "opacity_min": 0.05
                            }
                        }
                    },
                    "interactivity": {
                        "events": {
                            "onclick": {
                                "enable": true,
                                "mode": "push"
                            }
                        },
                        "modes": {
                            "push": {
                                "particles_nb": 1
                            }
                        }
                    },
                    "retina_detect": true
                }} />

            <div className="Content">
                <InView>
                    {({ inView, ref, entry }) => (
                        <div className="About-body" ref={ref}
                            id={inView ? ("inview") : ("outview")}>
                            <div className="Body-left">
                                <h2 className="Section-title">About Me</h2>
                                <IntroBlock />
                            </div>
                            <div className="Body-right">
                                <h2 className="Section-title">Tools I've Used</h2>
                                <ToolsBlock />
                            </div>
                        </div>
                    )}
                </InView>
            </div>
        </div>
    )
}

export default AboutPage;